import { motion } from "framer-motion";
import { Reveal } from "@/lib/motion";

const stats = [
  { num: "500+", label: "Activations Delivered" },
  { num: "24", label: "Countries Served" },
  { num: "30yrs", label: "In The Industry" },
  { num: "97%", label: "Client Retention" },
];

export default function Stats() {
  return (
    <section className="border-y border-white/10 bg-[#050505]" data-testid="stats-band">
      <div className="mx-auto grid max-w-[1600px] grid-cols-2 md:grid-cols-4">
        {stats.map((s, i) => (
          <Reveal
            key={s.label}
            delay={i * 0.08}
            className={`border-white/10 px-6 py-12 md:px-10 md:py-16 ${
              i !== 0 ? "border-l" : ""
            } ${i < 2 ? "border-b md:border-b-0" : ""}`}
          >
            <motion.div className="font-mono text-4xl font-bold tracking-tight md:text-6xl">
              {s.num}
            </motion.div>
            <div className="mt-3 font-mono text-[10px] uppercase tracking-[0.2em] text-white/40 md:text-xs">
              {s.label}
            </div>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
